module.exports = __webpack_public_path__ + "static/media/ilustracao_tela11.c5038e77.png";